import { render, staticRenderFns } from "./SkillsInventoryIndicatorsChart.vue?vue&type=template&id=ba80f44c&scoped=true&"
import script from "./SkillsInventoryIndicatorsChart.vue?vue&type=script&lang=js&"
export * from "./SkillsInventoryIndicatorsChart.vue?vue&type=script&lang=js&"
import style0 from "./SkillsInventoryIndicatorsChart.vue?vue&type=style&index=0&id=ba80f44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba80f44c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardSingleInfoCard: require('/workspace/components/Dashboard/DashboardSingleInfoCard.vue').default})
